module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.1 57.6"><defs><path id="a" d="M0 0h67.1v57.6H0z"/></defs><path class="st0" d="M67.1 22.1L41.3 0v10.6C32.3 11.5.2 17.5 0 57.7c0 0 7.8-25.3 41.3-26.2v12.8l25.8-22.2z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/share.svg
// module id = 120
// module chunks = 0